module.exports = __webpack_public_path__ + "static/media/notification.654821f5.svg";